import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@material-ui/core';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import ProductPreview from '../../../../common/ProductPreview';
import Message from '../../../../common/Message';
import { STATUS_CANCEL_PURCHASE } from '../../../../../constants/texts';
import { textMapper } from '../../../../../helpers/FormHelper';

const StatusCancelPurchase = ({ ...props }) => {
  const { mobile, motiveId } = props;

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <Container>
        <ProductPreview mobile={mobile} />

        <Message fullRounded message={STATUS_CANCEL_PURCHASE} severity="info" />
      </Container>
    </React.Fragment>
  );
};

StatusCancelPurchase.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
};

export default StatusCancelPurchase;
